import { ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { DocumentSendError } from '@dreryk/egabinet-ezla-frontend-api';

import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { Message, MessageOptions } from '@dreryk/react-components';

import { medicalLeaveTranslationKeys } from '../../../../translations';

import { StyledMedicalLeaveDocumentErrorsStatus } from './MedicalLeaveDocumentErrorsStatus.styled';
import { MedicalLeaveDocumentErrorsStatusContent } from './MedicalLeaveDocumentErrorsStatusContent';

enum MedicalLeaveZlaDocumentSendErrorType {
   ERROR = 'ERROR',
}

const useMedicalLeaveZlaDocumentSendErrorsMessageOptions = (): MessageOptions<
   typeof MedicalLeaveZlaDocumentSendErrorType
> => {
   const theme = useTheme();
   return {
      [MedicalLeaveZlaDocumentSendErrorType.ERROR]: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
      },
   };
};

type MedicalLeaveZlaDocumentSendErrorsStatusProps = {
   readonly errors: DocumentSendError[];
};

export const MedicalLeaveZlaDocumentSendErrorsStatus = (
   props: MedicalLeaveZlaDocumentSendErrorsStatusProps
): ReactElement => {
   const options = useMedicalLeaveZlaDocumentSendErrorsMessageOptions();
   const [firstError] = props.errors;

   return (
      <StyledMedicalLeaveDocumentErrorsStatus>
         <Message
            displayIndicator
            testId={'medicalLeaveDocumentErrors'}
            type={MedicalLeaveZlaDocumentSendErrorType.ERROR}
            options={options}
            label={
               props.errors.length === 1
                  ? createInterpolatedTranslationKey(
                       medicalLeaveTranslationKeys.common.documentSendErrors.externalSystemError,
                       { errorCode: firstError.errorCode, errorMessage: firstError.errorMessage }
                    )
                  : medicalLeaveTranslationKeys.common.documentSendErrors.externalSystemErrors
            }
            fullWidth
         >
            {props.errors.length === 1 ? null : <MedicalLeaveDocumentErrorsStatusContent errors={props.errors} />}
         </Message>
      </StyledMedicalLeaveDocumentErrorsStatus>
   );
};
